import React, { useState } from 'react';
import SafeImage from './SafeImage';
import EmbeddedModal from '@c/modals/EmbeddedModal';

export interface SpotlightCardProps {
  url?: string;
  profileImage: string;
  name: string;
  label?: string;
  logoSrc: string;
  logoAlt: string;
  logoWidth: number;
  customTitle?: string;
  className?: string;
  embed?: {
    closeIconColor?: string;
    bgImage?: string;
    includeHeading?: boolean;
    html: string;
  };
}

const SpotlightCard: React.FC<SpotlightCardProps> = ({
  url = '',
  profileImage,
  name,
  label = 'Visit',
  logoSrc,
  logoAlt,
  logoWidth,
  customTitle,
  className = '',
  embed,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);

  const Wrapper = (props: { children: React.ReactNode }) => {
    if (embed?.html && !url) {
      return (
        <div
          onClick={handleOpenModal}
          className={`cursor-pointer flex items-center sm:gap-8 gap-3 rounded-[1rem] border border-brand-primary px-4 transition-all hover:shadow-lg h-[10rem] w-[26rem] ${className}`}
        >
          {props.children}
        </div>
      );
    }

    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center sm:gap-8 gap-3 rounded-[1rem] border border-brand-primary px-4 transition-all hover:shadow-lg h-[10rem] w-[26rem] ${className}`}
      >
        {props.children}
      </a>
    );
  };

  return (
    <>
      <Wrapper>
        <div className="h-16 w-16 overflow-hidden rounded-full flex-shrink-0">
          <SafeImage
            src={profileImage}
            alt={name}
            width={64}
            height={64}
            className="h-full w-full object-cover"
          />
        </div>

        <div className="flex flex-col items-center flex-1">
          {embed?.html ? (
            <SafeImage
              src={logoSrc}
              alt={logoAlt}
              height={25}
              style={{ height: 25, width: 'auto' }}
            />
          ) : (
            <p className="text-[1.4rem] font-medium uppercase tracking-wider text-brand-gray">
              {label}
            </p>
          )}

          <p
            className={`sm:text-[1.75rem] text-[1.3rem] px-[2rem] font-bold text-brand-secondary ${embed?.html ? 'text-center' : ''
              }`}
          >
            {customTitle || `${name.split(' ')[0].toUpperCase()}'S`}
          </p>

          {!embed?.html && (
            <SafeImage
              src={logoSrc}
              alt={logoAlt}
              height={25}
              style={{ height: 25, width: 'auto' }}
            />
          )}
        </div>
      </Wrapper>

      {embed?.html && (
        <EmbeddedModal
          isOpen={openModal}
          html={embed.html}
          includeHeading={embed.includeHeading ?? false}
          bgImage={embed.bgImage}
          closeIconColor={embed.closeIconColor}
          dismiss={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default SpotlightCard;